import * as countriesFlagsPackage from 'country-flag-icons/react/3x2';
import AntillesFlag from '@flags/antilles-flag.svg?react';
import CirmeaFlag from '@flags/cirmea-flag.svg?react';
import LuhanskFlag from '@flags/luhansk-flag.svg?react';
import DonetskFlag from '@flags/donetsk-flag.svg?react';
// for adding new flag we need create svg file with 513X342 resultaion (3:2)
type CountryFlagType = keyof typeof countriesFlags;

const countriesFlags = {
...countriesFlagsPackage,
    AN: AntillesFlag,
    CE: CirmeaFlag,
    LN: LuhanskFlag,
    DN: DonetskFlag
};

function getCountryFlag(codeCountry: string) {
    return countriesFlags[codeCountry.toUpperCase() as CountryFlagType] || null;
}

export default getCountryFlag;